var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsrbM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.418,
    height: 90.628,
    viewBox: "0 0 60.418 90.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(-1099.581 -867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(1099.583 867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M274.488,513.478H214.07v90.628h60.417V513.478Z",
    transform: "translate(-214.07 -513.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(0.878 0.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M273.309,514.116V602.8H214.647V514.116h58.662",
    transform: "translate(-214.647 -514.116)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 52.336,
    height: 14.707,
    transform: "translate(2.952 3.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 52.366,
    height: 54.062,
    transform: "translate(2.928 21.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(2.938 78.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M216.577,572.732v-7.178H227.09v1.68H220.8v1.026h5.323v1.674H220.8v1.124h6.534v1.674Z",
    transform: "translate(-216.577 -565.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M232.041,567.706a.794.794,0,0,0-.611-.486,3.832,3.832,0,0,0-1.09-.132c-.929,0-1.344.151-1.344.419,0,1.061,7.413.4,7.413,3.007,0,1.661-2.492,2.474-6.034,2.474-3.4,0-5.619-1.107-5.709-2.4h4.044a1.033,1.033,0,0,0,.7.566,3.823,3.823,0,0,0,1.2.181c1.057,0,1.758-.187,1.758-.527,0-1.088-7.42-.342-7.42-3.078,0-1.524,2.366-2.29,5.589-2.29,3.578,0,5.208,1.015,5.517,2.27Z",
    transform: "translate(-212.351 -565.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M237.982,568.667h1.661c1.306,0,2.008-.19,2.008-.685s-.714-.749-1.7-.749h-1.969Zm0,1.564v2.5h-4.223v-7.178h6.088c4.29,0,5.708.656,5.708,2.051,0,.83-.661,1.519-2.165,1.761,1.358.273,2.183.443,2.183,1.891,0,.933-.055,1.258.446,1.258v.218h-4.281a2.793,2.793,0,0,1-.212-1.256c0-.942-.286-1.245-2.255-1.245Z",
    transform: "translate(-207.6 -565.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M247.432,567.233v1.2h1.761c.84,0,1.452-.216,1.452-.627,0-.562-.833-.574-1.72-.574Zm0,2.5v1.323h1.844c1.047,0,1.831-.122,1.831-.658,0-.627-.98-.665-2.331-.665Zm-4.22,3v-7.178h6.161c2.9,0,5.211.39,5.211,1.81,0,.74-.863,1.279-1.684,1.559,1.395.2,2.142.874,2.142,1.644,0,1.6-2.2,2.165-5.549,2.165Z",
    transform: "translate(-202.661 -565.374)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(4.826 24.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M217.817,540.308l16.059-4.327,9.159,21.567.077-.027-2.764-23.274,16.059-4.322,10.019,37.662-9.786,2.623-7.166-26.923-.077.03,3.034,28.023L241.839,574.2l-11.291-25.8-.08.021,7.152,26.923-9.781,2.629Z",
    transform: "translate(-217.817 -529.926)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(4.404 6.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M217.54,526.6v-8.328H219.9l1.1,5.662h.02l1.166-5.662h2.288V526.6h-1.431v-6.425h-.02l-1.352,6.425h-1.4l-1.286-6.425h-.018V526.6Z",
    transform: "translate(-217.54 -518.225)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M222.533,526.6l1.944-8.328h1.938l1.906,8.328h-1.547l-.388-1.847H224.38l-.4,1.847Zm2.832-6.725h-.023l-.67,3.6h1.4Z",
    transform: "translate(-214.931 -518.225)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M230.779,518.271v1.385h-1.634V526.6h-1.471v-6.943h-1.634v-1.385Z",
    transform: "translate(-213.099 -518.225)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M234.361,518.271v5.9a3.639,3.639,0,0,1-.122.932,2.407,2.407,0,0,1-.4.818,2.061,2.061,0,0,1-.735.589,2.584,2.584,0,0,1-1.13.222,2.237,2.237,0,0,1-1.8-.691,2.785,2.785,0,0,1-.589-1.87v-5.9h1.469v5.79a1.88,1.88,0,0,0,.248,1.1.791.791,0,0,0,.658.329.765.765,0,0,0,.708-.368,2.038,2.038,0,0,0,.227-1.063v-5.79Z",
    transform: "translate(-211.249 -518.225)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M234.957,526.6h-1.471v-8.328H236.2a1.466,1.466,0,0,1,1.2.556,2.555,2.555,0,0,1,.445,1.623,2.819,2.819,0,0,1-.3,1.35,1.366,1.366,0,0,1-1,.693v.024c.078.014.187.038.332.067a1.061,1.061,0,0,1,.422.209,1.319,1.319,0,0,1,.364.48,1.988,1.988,0,0,1,.157.88c0,.133,0,.317.006.554s.011.486.024.738.029.489.053.7a2,2,0,0,0,.081.452h-1.439a2.277,2.277,0,0,1-.152-.8c0-.277,0-.551,0-.818,0-.247,0-.483,0-.7a1.721,1.721,0,0,0-.1-.585.827.827,0,0,0-.312-.4,1.137,1.137,0,0,0-.636-.151h-.382Zm0-4.729h.653a.569.569,0,0,0,.361-.114.872.872,0,0,0,.23-.3,1.276,1.276,0,0,0,.126-.4,2.864,2.864,0,0,0,.033-.416,1.376,1.376,0,0,0-.2-.848.675.675,0,0,0-.55-.247h-.653Z",
    transform: "translate(-209.209 -518.225)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M237.06,526.6v-8.328h3.834v1.28h-2.363v2.055h2.179v1.279h-2.179v2.431h2.44V526.6Z",
    transform: "translate(-207.342 -518.225)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M241.587,519.538a6.8,6.8,0,0,0,.711-.565,3.48,3.48,0,0,0,.6-.732h1.3v8.373h-1.471v-6.442a4.914,4.914,0,0,1-.551.505c-.195.149-.393.294-.594.431Z",
    transform: "translate(-204.976 -518.241)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M247.959,519.838l-1.656,6.776h-1.527l1.86-7.076h-2.328v-1.3h3.651Z",
    transform: "translate(-203.555 -518.241)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M248.762,519.332h1.082v2.273h1.643v1.279h-1.643v2.271h-1.082v-2.271h-1.655v-1.279h1.655Z",
    transform: "translate(-202.092 -517.671)",
    fill: "#1a1818"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsrbM);
export default __webpack_public_path__ + "static/media/esrb-m.814d7ff24adb02f3cb957d7ae796c617.svg";
export { ForwardRef as ReactComponent };